module.exports =
{

  _init: function ()
  {

    APPLICATION._APPLICATION.processLinks("#developments", "CoinsDevelopment", "developments")

    $("#development_id").val("")

  }

}